import * as yup from "yup";
import { months } from "../constant";

export const CP_KEY = {
  PGM_TYPE: 'programType',
  QTY: 'unitQy',
  MFR: 'mfrName',
  MDL: 'modelName',
  PV_TILT: 'tilt',
  PV_AZI: 'azimuth',
  PV_TRK: 'tracking',
  PV_SH_QTY: 'shadeQty'
}

export const initialValues = {
  [CP_KEY.PGM_TYPE]: "",
  [CP_KEY.QTY]: "",
  [CP_KEY.MFR]: "",
  [CP_KEY.MDL]: "",
}

export const getInitialValues = (isSolar) => {
  return {
    [CP_KEY.PGM_TYPE]: "",
    [CP_KEY.QTY]: "",
    [CP_KEY.MFR]: "",
    [CP_KEY.MDL]: "",
    ...(isSolar ? {
      [CP_KEY.PV_TILT]: "",
      [CP_KEY.PV_AZI]: "",
      [CP_KEY.PV_TRK]: "",
      [CP_KEY.PV_SH_QTY]: "",
      ...(months.reduce((a, v) => ({ ...a, [v]: ''}), {}))
    } : {})
  }
}

export const validationSchema = yup.object().shape({
  [CP_KEY.PGM_TYPE]: yup.string().required('Required'),
});


export const subValidationSchema = yup.object().shape({
  [CP_KEY.QTY]: yup.string().required('Required'),
  [CP_KEY.MFR]: yup.string().required('Required'),
  [CP_KEY.MDL]: yup.string().required('Required'),
});


export const getValidationSchema = (isSolar) => yup.object().shape({
  [CP_KEY.QTY]: yup.string().required('Required'),
  [CP_KEY.MFR]: yup.string().required('Required'),
  [CP_KEY.MDL]: yup.string().required('Required'),
  ...(isSolar ? {
    [CP_KEY.PV_TILT]: yup.string()
    .when([CP_KEY.PV_TRK], {
      is: (value) => value !== 'dual',
      then: ()=>yup.string().required('Required'),
  }),
    [CP_KEY.PV_AZI]: yup.string()
    .when([CP_KEY.PV_TRK], {
      is: (value) => value !== 'dual',
      then: ()=>yup.string().required('Required'),
  }),
    [CP_KEY.PV_TRK]: yup.string().required('Required'),
    ...(months.reduce((a, v) => ({ ...a, [v]: yup.string().required('Required')}), {}))
  } : {})
});

//UTIL FUNCTIONS
export const onDeleteEquipment = (eqId, equipList, setEquipList) => {
  const newList = equipList.filter((el) => el.eqId !== eqId);
  setEquipList(newList);
};

export const onDeleteProduct = (eqId, pId, equipList, setEquipList, deviceNm) => {
  const eqItem = equipList.find((x) => x.eqId === eqId);
  const newState = [...equipList];
  const eqIndex = equipList.indexOf(eqItem);
  if (eqIndex >= 0) {
    const newList = newState[eqIndex][deviceNm].filter((el) => el.pId !== pId);
    newState[eqIndex][deviceNm] = newList;
    setEquipList(newState);
  }
};

export const onUpdateEquipment = (eqId, equipList, setEquipList, updatedObj) => {
  const eqItem = equipList.find((x) => x.eqId === eqId);
  const eqIndex = equipList.indexOf(eqItem);
  if (eqIndex >= 0) {
    const updateItem = {
      ...eqItem,
      ...updatedObj
    };
    const newState = [...equipList];
    newState[eqIndex] = updateItem;
    setEquipList(newState);
  }
};

export const onUpdateProduct = (eqId, pId, equipList, setEquipList, deviceNm, updatedObj) => {
  const eqItem = equipList.find((x) => x.eqId === eqId);
  const eqIndex = equipList.indexOf(eqItem);
  const pItem = equipList?.[eqIndex]?.[deviceNm]?.find((x) => x.pId === pId);
  const pIndex = equipList?.[eqIndex]?.[deviceNm]?.indexOf(pItem);
  if (eqIndex >= 0 && pIndex >= 0) {
    //Updating Modals value
    const updateItem = {
      ...pItem,
      ...updatedObj
    };
    const newState = [...equipList];
    newState[eqIndex][deviceNm][pIndex] = updateItem;
    setEquipList(newState);
  }
};

export const getModalListforDropDown = (eqList, id, pid, deviceNm) => {
  if (pid) {
    const eqItem = eqList.find((x) => x.eqId === id);
    const eqIndex = eqList.indexOf(eqItem);
    const pItem = eqList[eqIndex][deviceNm].find((x) => x.pId === pid);
    const pIndex = eqList[eqIndex][deviceNm].indexOf(pItem);
    //Updating Modals value
    return eqList[eqIndex][deviceNm][pIndex].mdl
  }
  else {
    return eqList.find(el => el.eqId === id).mdl
  }
}

export const calculateMaxCPwr=(pwr,qty)=>{
  if(pwr && qty)
  return (Number(qty) * Number(pwr)).toFixed(3)
}

const calculateSumEnergy = (item,kwKey) =>{
  return item?.length > 0 ? item?.reduce((a,v)=> a + Number(calculateMaxCPwr(v?.modelData?.[kwKey],v?.data?.[CP_KEY.QTY])),0): 0
}

export const calcTotalPC = (equipment,eqKwkey,isIES) =>{
 const ttlInvC = calculateMaxCPwr(equipment?.modelData?.[eqKwkey],equipment?.data?.[CP_KEY.QTY]) || 0;
 const ttlBtC = calculateSumEnergy(equipment?.battery,'MAX_CONT_DISC_RATE_KW') || 0;
 const ttlPvC = calculateSumEnergy(equipment?.solar,'NMP_CAP_UNIT_KW') || 0;
 const totSubC =  ttlBtC + ttlPvC ;
 const invTotC = (ttlInvC <= totSubC) ?  ttlInvC : totSubC; 
 return isIES ? Number(ttlInvC)+Number(totSubC) :  Number(invTotC)
}

const calculateSumCapacity = (item,kwKey,isIes) =>{
  return item?.length > 0? item?.reduce((a,v)=> a + calcTotalPC(v,kwKey,isIes),0): 0
}

export const calculateProgramCapacity = (pgm) => {
  const inverterPC = calculateSumCapacity(pgm?.data?.inverters,"MAX_CONT_PWR_UPF_KW") ||0
  const iesPC = calculateSumCapacity(pgm?.data?.integratedEnergySystems,"MAX_CONT_DISC_RATE_KW",true) || 0
  return Number(inverterPC + iesPC)
}
